import { PressResponder } from '@react-aria/interactions'
import { ConnectIntegrationTriggerProps } from 'components/ConnectIntegrationTrigger/Types'
import { useConnectIntegrationTrigger } from 'hooks/useConnectIntegrationTrigger/useConnectIntegrationTrigger'

export const ConnectIntegrationTrigger = ({ children, provider, onConnect }: ConnectIntegrationTriggerProps) => {
  const { handleConnect } = useConnectIntegrationTrigger({
    provider,
    onConnect,
  })

  return <PressResponder onPress={handleConnect}>{children}</PressResponder>
}
